module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('img', {
    staticClass: "small-image",
    style: ({
      width: _vm.width,
      height: _vm.height,
      objectFit: 'contain'
    }),
    attrs: {
      "src": _vm.imageSmall
    },
    on: {
      "click": function($event) {
        _vm.isOpen = true;
      }
    }
  }), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    staticClass: "modal",
    attrs: {
      "id": "myModal"
    }
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.isOpen = false;
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('img', {
    staticClass: "modal-content",
    attrs: {
      "id": "img01",
      "src": _vm.imageBig
    }
  }), _vm._v(" "), (_vm.caption) ? _c('div', {
    attrs: {
      "id": "caption"
    }
  }, [_vm._v(_vm._s(_vm.caption))]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6edeb0d3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/ImageModal.vue
// module id = 3256
// module chunks = 0